// @ts-nocheck
import axios from "axios";
import * as Sentry from "@sentry/react";
import { toast } from "sonner";

// Send the httpOnly admin-session cookie on every cross-origin API call
// (admin app :3030 ↔ api :1337). Replaces Clerk's Bearer-token auth.
axios.defaults.withCredentials = true;

// Tell the API which admin page issued the request — the audit log stores it
// (metadata.page) and the Staty Bug Alert email includes it.
axios.interceptors.request.use(function (config) {
  try {
    config.headers['X-Admin-Page'] = window.location.pathname;
  } catch (e) { /* non-browser context */ }
  return config;
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  console.log('===interceptor: success', response);
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  console.log('===interceptor: err', error);
  if (error.response?.status === 403) {
    // Surface the server's permission message (e.g. "Access denied:
    // insufficient scope") instead of leaving each store's generic catch to
    // swallow it. Fixed toast id dedupes bursts of parallel 403s; the flag
    // lets store catch blocks skip their own fallback toast.
    const message = error.response?.data?.error
      || "You don't have permission to perform this action";
    toast.error(message, { id: 'permission-error' });
    error.permissionToastShown = true;
    Sentry.captureException(error);
  }
  return Promise.reject(error);
});


export {
  axios
};